import { render, staticRenderFns } from "./ModalDeclineTermConfirm.vue?vue&type=template&id=474bc932&scoped=true&"
import script from "./ModalDeclineTermConfirm.vue?vue&type=script&lang=js&"
export * from "./ModalDeclineTermConfirm.vue?vue&type=script&lang=js&"
import style0 from "./ModalDeclineTermConfirm.vue?vue&type=style&index=0&id=474bc932&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "474bc932",
  null
  
)

export default component.exports